import { Controller } from "@hotwired/stimulus"

const SUPERVISOR_ROLES = ["president_director", "director_executive", "manager"]

export default class extends Controller {
  static targets = [ "roleSelect", "employeeFields", "clientFields", "notificationFields", "projectNotificationFields", "projectList" ]

  connect() {
    this.toggleRoleFields()
    this.toggleProjectList()
  }

  toggleRoleFields() {
    if (!this.hasRoleSelectTarget) return

    const isClient = this.roleSelectTarget.value === "client"
    const isEngineer = this.roleSelectTarget.value === "engineer"

    if (this.hasNotificationFieldsTarget) {
      this.notificationFieldsTarget.classList.toggle("hidden", isEngineer)
      this.notificationFieldsTarget.querySelectorAll("input").forEach((input) => {
        input.disabled = isEngineer
      })
    }

    if (!isClient) {
      if (this.hasEmployeeFieldsTarget) {
        this.employeeFieldsTarget.classList.remove("hidden")
        this.employeeFieldsTarget.querySelectorAll("input").forEach(input => input.removeAttribute("disabled"))
      }
      if (this.hasClientFieldsTarget) {
        this.clientFieldsTarget.classList.add("hidden")
        this.clientFieldsTarget.querySelectorAll("input, textarea").forEach(input => input.setAttribute("disabled", "true"))
      }
    } else {
      if (this.hasEmployeeFieldsTarget) {
        this.employeeFieldsTarget.classList.add("hidden")
        this.employeeFieldsTarget.querySelectorAll("input").forEach(input => input.setAttribute("disabled", "true"))
      }
      if (this.hasClientFieldsTarget) {
        this.clientFieldsTarget.classList.remove("hidden")
        this.clientFieldsTarget.querySelectorAll("input, textarea").forEach(input => input.removeAttribute("disabled"))
      }
    }

    // Runs last because it narrows down what the notification block above just
    // enabled: only supervisors choose which projects they hear about.
    this.toggleProjectNotificationFields()
  }

  toggleProjectNotificationFields() {
    if (!this.hasProjectNotificationFieldsTarget || !this.hasRoleSelectTarget) return

    const isSupervisor = SUPERVISOR_ROLES.includes(this.roleSelectTarget.value)

    this.projectNotificationFieldsTarget.classList.toggle("hidden", !isSupervisor)
    this.projectNotificationFieldsTarget.querySelectorAll("input").forEach((input) => {
      input.disabled = !isSupervisor
    })
  }

  toggleProjectList() {
    if (!this.hasProjectListTarget) return

    const checked = this.element.querySelector('input[name="user[project_notification_scope]"]:checked')
    this.projectListTarget.classList.toggle("hidden", checked?.value !== "selected_projects")
  }
}
